
function runElectricityDefaultAnimation() {
    // Gesamtproduktion

    var loop = new TimelineLite({onComplete:function() {
        this.restart()}
    });


    loop.from('#electricity-animation-ray-1', 0.4, {x: -10, y: 10})
    .from('#electricity-animation-ray-2', 0.4, {x: -10}, "-=0.30")
    .from('#electricity-animation-ray-3', 0.4, {x: -10, y: -10}, "-=0.30")
    .from('#electricity-animation-ray-4', 0.4, {y: -10}, "-=0.30")
    .from('#electricity-animation-ray-5', 0.4, {x: 10, y: -10}, "-=0.30")
    .from('#electricity-animation-ray-6', 0.4 , {x: 10}, "-=0.30")

    loop.to('#electricity-animation-ray-1', 0.4, {x: -10, y: 10})
    .to('#electricity-animation-ray-2', 0.4, {x: -10}, "-=0.30")
    .to('#electricity-animation-ray-3', 0.4, {x: -10, y: -10}, "-=0.30")
    .to('#electricity-animation-ray-4', 0.4, {y: -10}, "-=0.30")
    .to('#electricity-animation-ray-5', 0.4, {x: 10, y: -10}, "-=0.30")
    .to('#electricity-animation-ray-6', 0.4 , {x: 10}, "-=0.30")


    // Elektrizitätswerk

    TweenMax.to('#electricity-animation-signal', 2, {
        repeat: -1,
        opacity: 0,
        scaleY: 60,
        scaleX: 60,
        transformOrigin: 'center',
        ease: Sine.easeInOut,
        }
    );
}

function runElectricityAnimation() {

    // init
    var arrow_timeline = new TimelineLite();

    // config
    var arrow_animation_duration = 2;

    // left arrow
    var motionPath = MorphSVGPlugin.pathDataToBezier('#electricity-animation-line-path', {align: '#electricity-animation-moving-arrow'});

    TweenLite.set('#electricity-animation-moving-arrow', {xPercent:-70,yPercent:-50});

    arrow_timeline.add('arrow-animation');

    arrow_timeline.add(
        TweenLite.from('#electricity-animation-moving-arrow', arrow_animation_duration, {
            bezier: {
                values: motionPath,
                type: 'cubic',
                autoRotate: 180,
            },
            opacity: 0,
            ease: Power4.easeOut,
        }),
        'arrow-animation'
    )

    arrow_timeline.add(
        TweenLite.to('#electricity-animation-moving-arrow', arrow_animation_duration, {
            opacity: 1,
            ease: Power4.easeOut,
        }),
        'arrow-animation'
    )

    arrow_timeline.add(
        TweenLite.fromTo('#electricity-animation-line-path', arrow_animation_duration,
            {
                drawSVG: "100% 100%",
                opacity: 0,
            },
            {
                drawSVG: "0 100%",
                repeat: 0,
                opacity: 1,
                repeatDelay: 0.5,
                ease: Power4.easeOut,
            }
        ),
        'arrow-animation'
    )

    arrow_timeline.add(
        TweenLite.fromTo('#electricity-animation-icon', arrow_animation_duration/2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                ease: Power4.easeOut,
            }
        ),
        'arrow-animation'
    )

    // right arrow
    var motionPath = MorphSVGPlugin.pathDataToBezier('#electricity-animation-line-path-2', {align: '#electricity-animation-moving-arrow-2'});

    TweenLite.set('#electricity-animation-moving-arrow-2', {xPercent:-40,yPercent:-50});

    arrow_timeline.add('arrow-animation-2');

    arrow_timeline.add(
        TweenLite.to('#electricity-animation-moving-arrow-2', arrow_animation_duration, {
            opacity: 1,
        }),
        'arrow-animation-2'
    )

    arrow_timeline.add(
        TweenLite.to('#electricity-animation-moving-arrow-2', arrow_animation_duration, {
            bezier: {
                values: motionPath,
                type: 'cubic',
                autoRotate: 180,
            },
            ease: Power4.easeOut,
        }),
        'arrow-animation-2'
    )

    arrow_timeline.add(
        TweenLite.fromTo('#electricity-animation-line-path-2', arrow_animation_duration,
            {
                drawSVG: "0 0",
                opacity: 0,
            },
            {
                drawSVG: "0% 100%",
                repeat: 0,
                repeatDelay: 0.5,
                opacity: 1,
                ease: Power4.easeOut,
            }
        ),
        'arrow-animation-2'
    )

    arrow_timeline.add(
        TweenLite.fromTo('#electricity-animation-icon-2', arrow_animation_duration/2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                ease: Power4.easeOut,
            }
        ),
        'arrow-animation-2'
    )

    // top arrow
    var motionPath = MorphSVGPlugin.pathDataToBezier('#electricity-animation-line-path-3', {align: '#electricity-animation-moving-arrow-3'});

    arrow_timeline.add('arrow-animation-3');

    TweenLite.set('#electricity-animation-moving-arrow-3', {xPercent:25,yPercent:-70});

    arrow_timeline.add(
        TweenLite.from('#electricity-animation-moving-arrow-3', arrow_animation_duration, {
            bezier: {
                values: motionPath,
                type: 'cubic',
                autoRotate: -130,
            },
            ease: Power4.easeOut,
        }),
        'arrow-animation-3'
    )

    arrow_timeline.add(
        TweenLite.to('#electricity-animation-moving-arrow-3', arrow_animation_duration, {
            opacity: 1,
            ease: Power4.easeOut,
        }),
        'arrow-animation-3'
    )

    arrow_timeline.add(
        TweenLite.fromTo('#electricity-animation-line-path-3', arrow_animation_duration,
            {
                drawSVG: "100% 100%",
                opacity: 0,
            },
            {
                drawSVG: "0 99.9%",
                repeat: 0,
                repeatDelay: 0.5,
                opacity: 1,
                ease: Power4.easeOut,
            }
        ),
        'arrow-animation-3'
    )

    arrow_timeline.add(
        TweenLite.fromTo('#electricity-animation-icon-3', arrow_animation_duration/2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                ease: Power4.easeOut,
            }
        ),
        'arrow-animation-3'
    )

}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Run animation when it appears on screen

*/

import OnScreen from 'onscreen';

// config
let options = {
    tolerance: 150, // options.tolerance is the number of pixels an element is allowed to enter its container boundaries before calling its callback. Defaults to 0.
    debounce: 50, // options.debounce is the number of milliseconds to wait before calling an element's callback after the user has stopped scrolling. Defaults to 100.
    container: window // options.container is the container of the elements you want to track. It accepts a string representing a CSS selector or an HTMLElement object. Defaults to window.
};


function initElectricityAnimation() {
    const os = new OnScreen(options);
    // Do something when an element enters the viewport
    os.on('enter', '.flow-animation--electricity', (element) => {
        if (element.classList.contains('flow-animation--visible') === false) {
            element.classList.add('flow-animation--visible');
            // start animation after element has been faded in
            setTimeout(function(){
                runElectricityAnimation();
            },1000);
        }
    });
}

$(function(){

    // one page load
    runElectricityDefaultAnimation();
    initElectricityAnimation();

});



// WEBPACK FOOTER //
// ./static/js/modules/electricity-animation.js